// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { getUUID } from "@hex-insights/core";

export { projectName, mainServerAppName, jwtIssuer } from "@s-i-s-i/see-learning.shared";

export const appName = "Portal";
export const appVersion = process.env.REACT_APP_VERSION ?? "";
export const instanceID = getUUID();
